import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTheme } from 'styled-components';
import { Portal } from '../Portal';
import { StyledContent, StyledWrapper } from './Modal.style';
export function Modal({ size, portalTarget, children, onOverlayClick, isPricingModal, }) {
    const theme = useTheme();
    const contentRef = useRef(null);
    const handleClickOutside = useCallback((event) => {
        if (contentRef.current &&
            !contentRef.current.contains(event.target)) {
            onOverlayClick === null || onOverlayClick === void 0 ? void 0 : onOverlayClick();
        }
    }, [onOverlayClick]);
    const isMobile = useMediaQuery({ maxWidth: theme.Screen.Size.Small });
    return (_jsx(Portal, { target: portalTarget, children: _jsx(StyledWrapper, { onClick: handleClickOutside, children: _jsx(StyledContent, { ref: contentRef, size: size, isMobile: isMobile, isPricingModal: isPricingModal, children: children }) }) }));
}
//# sourceMappingURL=Modal.js.map